import { httpClient, ApiResponse } from '@/utils';
import {
  IGetAdminsListDTO,
  IAdminsListResponse,
  UsersEndpoints,
  IAdminDetailsDTO,
  IGetUsersListDTO,
  IUsersListResponse,
  IUserAuthData,
} from '@/models/users.model';
import { IAdminProfileResponse } from '@/models/admins.model';

class UsersAPI {
  static getAdminsList(data: IGetAdminsListDTO): ApiResponse<IAdminsListResponse> {
    return httpClient.get<IAdminsListResponse>(UsersEndpoints.ADMINS_LIST, { params: data });
  }

  static getUsersList(data: IGetUsersListDTO): ApiResponse<IUsersListResponse> {
    return httpClient.get<IUsersListResponse>(UsersEndpoints.USERS_LIST, { params: data });
  }

  static getAdminDetails(id: string): ApiResponse<IAdminProfileResponse> {
    return httpClient.get<IAdminProfileResponse>(`${UsersEndpoints.ADMINS_LIST}/${id}`);
  }

  static deleteAdmin(id: string): ApiResponse<IAdminProfileResponse> {
    return httpClient.delete<IAdminProfileResponse>(`${UsersEndpoints.ADMINS_LIST}/${id}`);
  }

  static updateAdminDetails(data: IAdminDetailsDTO): ApiResponse<IAdminsListResponse> {
    return httpClient.patch<IAdminsListResponse>(`${UsersEndpoints.ADMINS_LIST}/${data?.id}`, { ...data });
  }

  static toggleActiveUser(id: string): ApiResponse<IUsersListResponse> {
    return httpClient.patch<IUsersListResponse>(`${UsersEndpoints.USERS_LIST}/${id}/toggle-active`);
  }

  static createAdmin(data: IAdminDetailsDTO): ApiResponse<IAdminsListResponse> {
    return httpClient.post<IAdminsListResponse>(UsersEndpoints.ADMINS_LIST, { ...data });
  }

  static resendInvitation(id: string): ApiResponse<void> {
    return httpClient.post<void>(`${UsersEndpoints.ADMINS_LIST}/${id}/resend-invitation`);
  }

  static getUserAuthData(id: string): ApiResponse<IUserAuthData> {
    return httpClient.get<IUserAuthData>(`${UsersEndpoints.USERS_LIST}/${id}/login-as`);
  }
}

export default UsersAPI;
